export default __webpack_public_path__ + "static/media/intro.d1e5f078.mp4";